import React from 'react';

const Spade = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100'
      className='icon'
      version='1.1'
      viewBox='0 0 120 120'
    >
      <g>
        <path
          fill='#003f12'
          fillOpacity='0.941'
          strokeWidth='0.282'
          d='M18.733 119.693c2.75-.498 5.604-1.526 9.126-3.287 5.29-2.644 7.293-4.248 15.637-12.519l7.747-7.678-3.662-3.69c-2.275-2.293-4.066-3.856-4.727-4.126-1.624-.665-1.807-1.27-.91-3.002 2.666-5.142 4.55-7.173 21.975-23.686 3.099-2.936 8.676-8.343 12.394-12.016 3.719-3.672 8.853-8.532 11.41-10.8 4.266-3.784 4.716-4.109 5.492-3.953.465.093 2.05.24 3.523.327 2.388.14 2.915.078 4.868-.577 2.998-1.006 5.512-2.319 8.497-4.436 3.108-2.205 10.024-8.88 10.018-9.67-.006-.764-18.824-19.577-19.587-19.58-.798-.005-7.489 6.919-9.67 10.005-2.123 3.006-4.072 6.9-4.713 9.419-.451 1.769-.437 5.134.03 7.474.156.782-.201 1.25-4.826 6.336-2.747 3.02-7.991 8.66-11.654 12.533a3110.195 3110.195 0 00-9.026 9.575c-3.106 3.326-11.424 11.876-13.932 14.32-3.012 2.936-8.836 7.502-10.542 8.264-2.13.952-2.845.805-3.584-.736-.357-.743-2.032-2.69-4.15-4.823l-3.552-3.576-7.544 7.638C9.216 85.686 7.276 88.098 4.712 93.166c-2.985 5.9-4.079 10.674-3.508 15.315.948 7.714 2.054 9.41 6.94 10.647 4.067 1.03 7.12 1.193 10.589.565zm75.349-88.544c-3.1-1.505-4.691-4.078-4.886-7.898-.146-2.845.36-5.093 1.773-7.901.98-1.947 3.177-5.048 4.731-6.68l.878-.922 8.248 8.242c4.537 4.534 8.248 8.378 8.248 8.543 0 .406-3.442 3.364-5.307 4.561-3.252 2.088-6.052 2.903-9.622 2.803-2.145-.06-2.952-.208-4.063-.748z'
        ></path>
      </g>
    </svg>
  );
};

export default Spade;
